import S from 'string';
import { mapKeysDeep } from './lodashUtils';

function camelizeKey(value, key) {
  return S(key).camelize().s;
}

function underscoreKey(value, key) {
  return S(key).underscore().s;
}

function assignDeeplyTo(that, data) {
  Object.assign(that, mapKeysDeep(data, transformKey));
}

function updateQueryParams(paramsWithValues, { resetParams = false } = {}) {
  const searchParams = resetParams
    ? new window.URLSearchParams()
    : new window.URLSearchParams(window.location.search);
  paramsWithValues.forEach(pair => {
    searchParams.set(pair.key, pair.value);
  });
  window.location.search = searchParams.toString();
}

export { camelizeKey, underscoreKey, assignDeeplyTo, updateQueryParams };
